import React from "react";
import './productoverlay.css';

const ProductOverlay = (props) => {
    return (
        <div className="overlay-banner">

            
            <div className="overlay-gradient" />

            
            <div className="overlay-noise" />

            
            <div className="overlay-vignette" />

            
            <div className="overlay-lines">
                <div className="overlay-line" />
                <div className="overlay-line" />
            </div>

           
            <div className="overlay-content">
                <div className="overlay-eyebrow">Asava Pharmaceuticals</div>
                <h1 className="overlay-heading">
                    <em>{props.heading}</em>
                </h1>
            </div>

        </div>
    );
};

export default ProductOverlay;